// Copyright © 2026 Alex Bruce. All rights reserved.
//
// Flags for work that is built but deliberately not in front of users.

/**
 * The in-app construction budget: cost report, cost event log, commitments,
 * allowances, contingency.
 *
 * Off by decision, not because it is broken. Most estimators who would use
 * OpenEstimate already run Procore, and a construction cost report is
 * Procore's job — it owns the commitments, the change management and, through
 * an accounting integration, the job-to-date actuals that OpenEstimate has no
 * way to obtain. A report with an empty actuals column is a report nobody
 * trusts.
 *
 * What OpenEstimate owns is the handoff: turning a finished estimate into a
 * Procore budget without a retype, and knowing what is left to buy out. Those
 * live in the Procore export and the Buyout tab.
 *
 * The module stays in the codebase — BudgetView, lib/budget.ts and its tests —
 * so revisiting it later is a flag flip rather than an archaeology project.
 */
export const BUDGET_ENABLED = false;
